import { useEffect } from 'react';

// List of critical assets to preload
const criticalAssets = [
  '/src/assets/images/logo.svg',
  '/src/assets/images/gym/gym-image-4.jpg'
];

const Preload = () => {
  useEffect(() => {
    // Preload critical assets
    criticalAssets.forEach(asset => {
      const link = document.createElement('link');
      link.rel = 'preload';
      link.as = asset.endsWith('.svg') ? 'image' : 'image';
      link.href = asset;
      link.crossOrigin = 'anonymous';
      document.head.appendChild(link);
    });
  }, []);

  return null;
};

export default Preload;
